import { ReactNode, useEffect, useState } from "react";
import { emptyLead, ILead } from "../../../../types/lead.type";
import { getLeadById, updateLead } from "../../../../common/services/leads.api";
import { initialState, LeadDashboardContext } from "./LeadDashboard.context";

type Props = {
  children: ReactNode,
  leadId: string
}

export function LeadDashboardProvider(props: Props) {

  const [lead, setLead] = useState<ILead>(initialState.lead)

  function normalizeLead(leadData?: Partial<ILead> | null): ILead {
    const base = emptyLead();

    return {
      ...base,
      ...leadData,
      companyId: leadData?.companyId || base.companyId,
      documents: Array.isArray(leadData?.documents) ? leadData.documents : base.documents,
      references: Array.isArray(leadData?.references) ? leadData.references : base.references,
      observations: Array.isArray(leadData?.observations) ? leadData.observations : base.observations,
      pendencies: Array.isArray(leadData?.pendencies) ? leadData.pendencies : base.pendencies,
      address: leadData?.address || base.address,
      criminalCheckLead: leadData?.criminalCheckLead || base.criminalCheckLead,
      cpfDoIndicadorOptions: leadData?.cpfDoIndicadorOptions || base.cpfDoIndicadorOptions,
      jurValidation: leadData?.jurValidation || base.jurValidation,
      externalReferences: leadData?.externalReferences || base.externalReferences,
    };
  }

  useEffect(() => {
    async function loadLead(leadId: string) {
      const result = await getLeadById(leadId)

      if (result.ok) {
        setLead(normalizeLead(result.data as ILead))
      } else {
        setLead(emptyLead())
      }
    }

    loadLead(props.leadId)
  }, [props.leadId])

  async function saveLead(dataToSave: ILead) {
    try {
      const { ok, data, errors } = await updateLead(lead._id as string, dataToSave)

      if (ok && data) {
        const normalizedLead = normalizeLead(data as ILead)
        setLead(normalizedLead)
        return { ok, data: normalizedLead, errors: (errors as [{ message: string, path: string[] }]) }
      }

      return { ok, data: normalizeLead(data as ILead), errors: errors as [{ message: string, path: string[] }] }
    } catch (err) {
      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }]
      }
    }
  }

  const theState = { lead, saveLead }

  return (
    <LeadDashboardContext.Provider value={theState}>
      {props.children}
    </LeadDashboardContext.Provider>
  )
}
